"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplaceCarAlertBannerWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var ReplaceCarAlertBannerWidget = /** @class */ (function (_super) {
    __extends(ReplaceCarAlertBannerWidget, _super);
    function ReplaceCarAlertBannerWidget(props) {
        return _super.call(this, props) || this;
    }
    ReplaceCarAlertBannerWidget.prototype.render = function () {
        var vehicleWording = this.props.engine.getInteraction().vehicles[0].make + " "
            + this.props.engine.getInteraction().vehicles[0].model
            + " (" + this.props.engine.getInteraction().vehicles[0].registrationNumber + ")";
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "price-transparency-widget display-block _panel rounded bg-white-blue p-3 d-table-cell", children: [(0, jsx_runtime_1.jsx)("img", { className: "m-4 float-left", src: "/img/alert-grey-blue.svg", alt: "Grey alert icon" }), (0, jsx_runtime_1.jsx)("div", { className: "line-height-15 m-3", children: (0, jsx_runtime_1.jsxs)("label", { children: ["Unfortunately ", vehicleWording, " doesn't meet our underwriting criteria and we can't cover it."] }) })] }) }));
    };
    return ReplaceCarAlertBannerWidget;
}(plugin_journey_1.WidgetBase));
exports.ReplaceCarAlertBannerWidget = ReplaceCarAlertBannerWidget;
//# sourceMappingURL=ReplaceCarAlertBannerWidget.js.map